import React, { Fragment, useRef, useState } from "react";
import "./Toggle.css";
import {getAuthorization} from "../../../axios/AxiosAut";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import "animate.css";
import * as Yup from "yup";
import CustomerListTableData from "./CustomerListTableData";
import CustomerToggle from "./CustomerToggle";
import { useNavigate } from "react-router-dom";
import Customerdata from "./Customermanagment/Customerdata";
import { useDispatch, useSelector } from "react-redux";

function CustomerDashboard() {
  const [Toggle, setToggle] = useState("Overview");
  const Navigate = useNavigate();
  const Permissions = useSelector((state) => state.user.userPermissions);
  const adduser = Permissions.find((o) => o.codename === "add_customer");
  const toggleHandler = () => {
    if (Toggle == "List") {
      setToggle("Overview");
    } else {
      setToggle("List");
      console.log("Permissions........", Permissions);
      console.log("adduser....", adduser);
      // console.log("{Permissions[0].codename}", Permissions[0].codename)
    }
  };
  const AddCustomerHandler = () => {
    Navigate("/dashboard/management/customer-dashboard/add-customer");
  };

  return (
    <>
      <div className="flex flex-col container max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <div>
              {Toggle == "Overview" ? (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Customers Dashboard
                  </h2>
                  <div className="border-b-2 border-blue-200 w-24"></div>
                </>
              ) : (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Customers
                  </h2>
                  <div className="border-b-2 border-blue-200 w-12"></div>
                </>
              )}
            </div>
          </div>
          <div>
            {/* {Permissions[0].codename} */}
            {Toggle == "Overview" ? null : 
          !adduser ===undefined ||  adduser?.codename ===
              "add_customer" ? (
              <button
                type="button"
                onClick={AddCustomerHandler}
                className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
              >
                Add Customer
              </button>
            ) : null
            }
          </div>
        </div>
        <CustomerToggle ToggleHandler={toggleHandler} Toggle={Toggle} />
      </div>
      <div className="flex flex-col max-w-4xl mt-2 mb-5 xl:max-w-7xl">
        {Toggle == "Overview" ? <Customerdata /> : <CustomerListTableData />}
      </div>
    </>
  );
}

export default CustomerDashboard;
